var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 352C72 338.7 82.75 328 96 328C109.3 328 120 338.7 120 352C120 365.3 109.3 376 96 376C82.75 376 72 365.3 72 352zM376 352C376 365.3 365.3 376 352 376C338.7 376 328 365.3 328 352C328 338.7 338.7 328 352 328C365.3 328 376 338.7 376 352zM440.2 70.2C446.2 78.14 448 87.36 448 95.15V384C448 407.7 435.1 428.4 416 439.4V496C416 504.8 408.8 512 400 512C391.2 512 384 504.8 384 496V448H64V496C64 504.8 56.84 512 48 512C39.16 512 32 504.8 32 496V439.4C12.87 428.4 0 407.7 0 384V95.15C0 87.42 1.788 77.91 8.304 69.88C32.5 40.06 100.2 0 224 0C356.6 0 417.2 39.95 440.2 70.2V70.2zM32 95.15V96H416V95.15C416 92 415.2 90.3 414.7 89.53C399.9 70.12 350.8 32 224 32C106.1 32 49.24 70.22 33.15 90.05C32.77 90.51 32 91.94 32 95.15zM32 128V256H416V128H32zM416 288H32V384C32 401.7 46.33 416 64 416H384C401.7 416 416 401.7 416 384V288z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusSimple);
export default __webpack_public_path__ + "static/media/bus-simple.ddc3fcade1ebbf8a35f371254bc4f2d6.svg";
export { ForwardRef as ReactComponent };